module.exports = __webpack_public_path__ + "2f02820377cb43817c88dd6fd91d4739.fbx";